export default class SliderDots
{
    protected root: HTMLElement;
    protected wrapper: HTMLElement;
    protected current: number = 0;
    protected options: any;
    protected scrollableOffset: number = 0;

    protected classes = {
        side: 'slider-dots__dot_side',
        out: 'slider-dots__dot_out',
        active: 'slider-dots__dot_active',
        usual: 'slider-dots__dot',
    }
    
    protected defaultOptions = {
        count: 1,
        scrollable: {
            enabled: false,
            visibleDots: 3,
        }
    };

    public constructor(root: string|Element, options: object = {})
    {
        if (typeof root === 'string') {
            root = document.querySelector(root);
        }

        if (root === null) {
            return;
        }

        this.root = root as HTMLElement;
        this.wrapper = root.firstElementChild as HTMLElement;

        if (this.wrapper === null) {
            return;
        }

        this.options = {...this.defaultOptions, ...options};
        this.options.scrollable.bigDotsCount = this.options.scrollable.visibleDots; 
        this.options.scrollable.visibleDots += 2;

        this.options.scrollable.enabled = this.options.scrollable.enabled
            && this.options.scrollable.bigDotsCount < this.options.count;
    }

    public init()
    {
        this.renderDots();
        this.update();
        this.switchClasses();
    }

    public scrollTo(idx: number)
    {
        this.scroll(idx);
        this.switchClasses();
    }

    public update()
    {
        if (this.options.scrollable.enabled) {
            let width = this.wrapper.querySelector<HTMLElement>('.' + this.classes.usual + ':not(.' + this.classes.active + ')').clientWidth;
            this.root.style.width = (width * this.options.scrollable.bigDotsCount + width * 2 + 48) + 'px';
        }
    }

    protected scroll(idx: number)
    {
        this.current = idx;
        
        if (this.options.scrollable.enabled) {
            let bigDotsCount = this.options.scrollable.bigDotsCount;
            let width = this.wrapper.querySelector<HTMLElement>('.' + this.classes.usual + ':not(.' + this.classes.active + ')').clientWidth;

            if (this.current > this.scrollableOffset + bigDotsCount) {
                this.scrollableOffset += this.current - (this.scrollableOffset + bigDotsCount);
            }

            if (this.current - 1 < this.scrollableOffset) {
                this.scrollableOffset = this.current - 1;
            }

            this.wrapper.style.marginLeft = -this.scrollableOffset * width + 'px';
        }
    }

    protected switchClasses() {
        let dots = this.wrapper.children;
        let bigDotsCount = this.options.scrollable.bigDotsCount;

        for (let i = 0; i < dots.length; i++) {
            dots[i].classList.remove(this.classes.side, this.classes.out, this.classes.active);

            if (this.options.scrollable.enabled) {
                if (i === this.scrollableOffset || i === this.scrollableOffset + bigDotsCount + 1) {
                    dots[i].classList.add(this.classes.side);
                }

                if (i < this.scrollableOffset || i > this.scrollableOffset + bigDotsCount + 1) {
                    dots[i].classList.add(this.classes.out);
                }
            }

            if (i === this.current) {
                dots[i].classList.add(this.classes.active);
            }
        }
    }

    protected renderDots()
    {
        this.wrapper.innerHTML = '';

        for (let i = 0; i < this.options.count; i++) {
            let dot = document.createElement('span');
            dot.classList.add(this.classes.usual, 'js-slider-control');
            dot.dataset.dir = i.toString();

            this.wrapper.appendChild(dot);
        }
    }
}
